import { render, staticRenderFns } from "./Muted.vue?vue&type=template&id=b63a86ac&scoped=true&"
import script from "./Muted.vue?vue&type=script&lang=ts&"
export * from "./Muted.vue?vue&type=script&lang=ts&"
import style0 from "./Muted.vue?vue&type=style&index=0&id=b63a86ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a86ac",
  null
  
)

export default component.exports